import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import type { VarianceIncidentDetailsClient } from '../../../../../core/tokens/variance-incident-details-client.token';
import type { VarianceIncident } from '../models/variance-incident.model';
import { VarianceSupportingDataMockService } from './variance-supporting-data-mock.service';

@Injectable({ providedIn: 'root' })
export class VarianceIncidentDetailsMockService implements VarianceIncidentDetailsClient {
  private readonly backing = inject(VarianceSupportingDataMockService);

  getIncidentDetails(incidentNumber: string, _organizationId: string): Observable<VarianceIncident> {
    return this.backing.getIncidentDetails(incidentNumber);
  }
}
